import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function usePassages() {
  const { visible, time, mode } = useAppSelector((state) => state.passage);
  const { date } = useAppSelector((state) => state.filters);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  const mapdata = {
    ScenarioUniqueId: "8219b30d-fbad-4e73-b9c1-36b01326461b",
    ServiceUniqueId: "bd9705fd-2058-45b4-a49e-0a29a36fa8ed",
    IncludeNonServiceBranches: false,
    Parameters: {
      "b2364eae-7f01-11ef-8d00-1062eb32e4ff": time.from,
      "b2364eb0-7f01-11ef-8d00-1062eb32e4ff": time.to,
      "a589a28f-216b-4de8-a1da-a8499b63ec5e": date.created_after || "2020-06-03",
      "510f03b9-d0e5-4bdd-a5e2-f4a066cb0bb3": date.created_before || "2025-06-03",
    },
    InputTables: [],
    OutputColumns: [],
  };

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: [visible, mode],
    queryFn: () => {
      return Api.sPost(
        "https://report2.ardban.ir:7072/https://report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute",
        mapdata
      ).then((res) => {
        console.log(res.data.Rows, "hzefbhrezrbh");
        return res.data.Rows;
      });
    },
    enabled: visible,
  });

  return { data, isLoading, refetch, isFetching };
}
